import jsPDF from 'jspdf';
import { getAdministratorFromLocalStorage, getCurrentDateTime } from '../utilities';
export const generateHeaderPDF = (doc: jsPDF) => {
    // eslint-disable-next-line
    const logoImage = require('@/assets/images/logos/logo-clipp-buses.png');
    doc.addImage(logoImage, "PNG", 120, 2, 70, 38);

    doc.setFont('VisbyRoundCF', 'bold');
    doc.setFontSize(12);
    doc.text("Sistema de Control de Flota, Monitoreo Satelital, Gestión y Recaudo - Caja Común", 80, 43);
}

export const generateFooterPDF = (doc: jsPDF) => {
    const pageHeight = doc.internal.pageSize.getHeight();

    doc.setFont('VisbyRoundCF', 'bold');
    doc.setFontSize(11);
    doc.text("Reporte generado automáticamente por el sistema Clipp Buses 3.0", 20, pageHeight - 20);

    doc.setFont('VisbyRoundCF', 'bold');
    doc.text("Usuario:", 20, pageHeight - 15);

    doc.setFont('VisbyRoundCF', 'normal');
    const admin = getAdministratorFromLocalStorage();
    doc.text(admin.first_name + " " + admin.last_name, 35, pageHeight - 15);

    doc.setFont('VisbyRoundCF', 'bold');
    doc.text("Fecha:", 20, pageHeight - 10);

    doc.setFont('VisbyRoundCF', 'normal');
    doc.text(getCurrentDateTime(), 32, pageHeight - 10);
}